/* unplugin-vue-components disabled */import { render } from "./drawNew.vue?vue&type=template&id=a05584c2&scoped=true"
import script from "./drawNew.vue?vue&type=script&lang=js"
export * from "./drawNew.vue?vue&type=script&lang=js"

import "./drawNew.vue?vue&type=style&index=0&id=a05584c2&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a05584c2"]])

export default __exports__